import classNames from 'classnames'
import { ComponentType } from 'react'

import { FlexCol } from '../../../common/frontend/components/flex-col/flex-col.js'
import { Toggle } from '../../components/forms/toggle/toggle.js'
import type { IconProps } from '../../components/icon/icon.js'
import { Signature, SignatureProps } from '../../components/signature/signature.js'

export interface SignaturePreviewProps {
    previewTitle: string
    isDark: boolean
    onDarkModeChange: (isDark: boolean) => void
    signatureProps: SignatureProps
    darkModeIconOn?: ComponentType<IconProps>
    darkModeIconOff?: ComponentType<IconProps>
}

export const SignaturePreview = (props: SignaturePreviewProps) => {
    return (
        <FlexCol className="signature-creation__column">
            <div
                className={classNames(
                    'signature-creation__preview',
                    props.isDark && 'signature-creation--dark-preview',
                )}
            >
                <div className="signature-creation__preview-header">
                    <h3>{props.previewTitle}</h3>
                    <Toggle
                        value={props.isDark}
                        onChange={props.onDarkModeChange}
                        IconOn={props.darkModeIconOn}
                        IconOff={props.darkModeIconOff}
                    />
                </div>
                <div className="signature-creation__preview-body">
                    <Signature {...props.signatureProps} />
                </div>
            </div>
        </FlexCol>
    )
}
